import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledDeleteBudgetFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        justify-content: flex-end;
        gap: ${spacing * 2}px;
    `
)

export const StyledDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-areas:
            'title last_name last_name first_name first_name'
            'service_uoc service_uoc service_uoc service_uoc service_uoc'
            'email email email email email';
        column-gap: ${spacing * 2.5}px;
        row-gap: ${spacing * 4}px;
        & > *:last-child {
            grid-column: span 2;
        }

        &.specialist-grid {
            & > *:first-child {
                grid-area: title;
            }
            & > *:nth-child(2) {
                grid-area: last_name;
            }
            & > *:nth-child(3) {
                grid-area: first_name;
            }
            & > *:nth-child(4) {
                grid-area: service_uoc;
                grid-column: span 3;
            }
            & > *:nth-child(5) {
                grid-area: email;
            }
        }
    `
)
